// extracted by mini-css-extract-plugin
export var component = "CoverLink-module--component--Jv+OP";
export var current = "CoverLink-module--current--zq2uY";
export var inert = "CoverLink-module--inert--cp7Xz";
export var label = "CoverLink-module--label--D1meX";